import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LocationRepository } from '@core/data/location/location.repository';
import { Location } from '@core/data/location/location.model';

;

export class LocationRepositoryHttp extends LocationRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/locations`
  listBySite(siteId: number): Observable<Location[]> {
    return this.http.get<Location[]>(`${this.baseUrl}?siteId=${siteId}`)
  }

  getById(locationId: number): Observable<Location | null> {
    return this.http.get<Location>(`${this.baseUrl}/${locationId}`)
  }

  listAll(): Observable<Location[]> {
    return this.http.get<Location[]>(`${this.baseUrl}`)
  }
}
